"use client";

export default function Logoticker() {
  const items = [{
    name: "Meta",
    type: "Meta Business Partner",
    logo: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/barbershop_logo_circle.png?v=xins45j9n9l"
  }, {
    name: "Google",
    type: "Google Ads Certified",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/Kuster_Energy_Logo.svg.png"
  }, {
    name: "Shopify",
    type: "Shopify Expert Agency",
    logo: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/circle_transparent.png?v=pswhnr2cel"
  }, {
    name: "Snapchat",
    type: "Snapchat Ads Partner",
    logo: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/Scherm­afbeelding-2026-07-02-om-20.55.26.png?v=lk9k84il86"
  }, {
    name: "Partner",
    type: "",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/Eindbaars-logo-donker-groen-klein.png"
  }];
  const loop = [...items, ...items, ...items];
  return <section data-section-id="4868" id="logoticker" className="bg-background text-foreground border-t border-b border-border/60 overflow-hidden py-12" style={{
    minHeight: "140px"
  }}>
      <h2 className="text-center text-sm md:text-base font-bold uppercase tracking-widest mb-8 text-secondary-foreground">bedrijven waarmee we hebben samengewerkt:</h2>
      <style>{`
        @keyframes forge-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .forge-marquee-track {
          animation: forge-marquee 30s linear infinite;
          will-change: transform;
        }
        .forge-marquee-wrapper:hover .forge-marquee-track {
          animation-play-state: paused;
        }
      `}</style>

      <div className="h-full w-full flex items-center">
        <div className="flex items-center h-full w-full">
          {}
          <div className="flex items-center h-full pl-6 md:pl-10 shrink-0">
            
            <div className="hidden md:block h-12 w-px bg-border/70 ml-8" aria-hidden="true" />
          </div>

          {}
          <div className="relative flex-1 h-full overflow-hidden forge-marquee-wrapper">
            {}
            <div className="pointer-events-none absolute left-0 top-0 h-full z-10" style={{
            width: "40px",
            background: "linear-gradient(to right, var(--background), transparent)"
          }} aria-hidden="true" />
            {}
            <div className="pointer-events-none absolute right-0 top-0 h-full z-10" style={{
            width: "40px",
            background: "linear-gradient(to left, var(--background), transparent)"
          }} aria-hidden="true" />

            <div className="forge-marquee-track flex items-center h-full w-max">
              {loop.map((item, i) => {
              return <div key={`${item.name}-${i}`} data-index={i} className="flex items-center justify-center shrink-0" style={{
                paddingLeft: "48px",
                paddingRight: "48px"
              }}>
                  <button type="button" className="group flex items-center justify-center bg-transparent outline-none focus-visible:ring-2 focus-visible:ring-primary/60" aria-label={item.type ? `${item.name} — ${item.type}` : "Partner logo"}>
                    <img src={item.logo} alt={item.name} loading="lazy" decoding="async" className="group-hover:opacity-100 transition-opacity duration-300 select-none" style={{
                    height: "48px",
                    width: "auto",
                    filter: "none"
                  }} />
                  </button>
                </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}